import React, { useEffect, useState, useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_PATH } from "../../constants/Global";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
import DataService from "../../services/tutorial.service";
import ExternalDataService from "../../services/external.service";
import Demo from "../crop/Demo";
import { useSelector, useDispatch } from "react-redux";
import { teamlistData, actlistData, setisfirsttime } from "../../actions/index";
import { decode } from "base-64";
import { getAlpha } from "../../Helpers/Helpers";
import { teamdefaultLogo } from "../../constants/Images";
import { Image, Shimmer } from "react-shimmer";
import $ from "jquery";
import ColorPicker from "./ColorPicker";
import {
  getDatabase,
  ref,
  remove,
  onValue,
  set,
  update,
  push,
  query,
  orderByChild,
  limitToLast,
  get,
} from "firebase/database";
import ImageCropper1 from "../cropper/ImageCropper";
import ImageCropper2 from "../utils/Demo";
import { FirebaseContext } from "../../FirebaseContext";

function Editteam(match) {
  const dispatch = useDispatch();
  const getpageData = useSelector((state) => state.setteamlistData);
  const [color, setColor] = useState("");
  const [color1, setColor1] = useState("");
  const [color2, setColor2] = useState("");
  const [color3, setColor3] = useState("");
  const [color4, setColor4] = useState("");
  const [srtkeyval, setsrtkeyval] = useState("");
  const [srtkeyvalnew, setsrtkeyvalnew] = useState("");
  const [showColor, setshowColor] = useState(false);
  const [showColor1, setshowColor1] = useState(false);
  const [showColor2, setshowColor2] = useState(false);
  const [showColor3, setshowColor3] = useState(false);
  const [showColor4, setshowColor4] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();
  const [isDisabled, setDisabled] = useState(false);
  const [logo, setLogo] = useState(null);
  const history = useHistory({ forceRefresh: true });
  const loginuser = useSelector((state) => state.setUserlog);
  const [cropData, setCropData] = useState("#");
  //const [srtkey,srtkeyText] = useState();
  const { tid } = useParams();
  const aid = localStorage.getItem("auction_id");
  const [cid, setCid] = useState(loginuser["cid"]);
  const [croppedImage, setCroppedImage] = useState("");
  const [originalFileName, setOriginalFileName] = useState("");
  const [defimg, setdefimg] = useState(teamdefaultLogo);
  const [alphabetsInArray, setalphabetsInArray] = useState("");
  const updtoken = useSelector((state) => state.updtoken);
  const [admin_id, setadminid] = useState(localStorage.getItem("admin_id"));
  const [admin_name, setadmin_name] = useState(
    localStorage.getItem("admin_name")
  );
  const auction_name = localStorage.getItem("auction_name");
  const [isUploading, setIsUploading] = useState(false);


  const { upddata } = useContext(FirebaseContext);
  const isfirsttime = useSelector((state) => state.isfirsttime);
  const getaucpageData = useSelector((state) => state.setactlistData);
  const aucmoredetail = useSelector((state) => state.actmoredata);

  let logo_pic = "";

  const onSubmit = async (values) => {
if (isUploading) return;

  setIsUploading(true);

    console.log("it is...");
    if (document.getElementById("logo_pic") != null) {
      logo_pic = document.getElementById("logo_pic").value;
    }
    setDisabled(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
    });
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    // values["logo_pic"] = croppedImage;
    values["color"] = color;
    values["forcolor1"] = color1;
    values["forcolor2"] = color2;
    values["forcolor3"] = color3;
    values["forcolor4"] = color4;
    // console.log("values")
    // console.log(values)

    // Bypass = no getSignedUrl call. Only call presigned when no_presignimg === 0.
    if (croppedImage && croppedImage !== "" && croppedImage !== "#") {
      const noPresignImg = aucmoredetail?.data?.no_presignimg ?? aucmoredetail?.no_presignimg;
      if (noPresignImg === 0) {
        const filename = originalFileName;
        const formData = new FormData();
        formData.append("filename", filename);
        formData.append("fltyp", "teamlogo");
        let externalResponse;
        try {
          console.log("uploading file to external API......");
          externalResponse = await ExternalDataService.getSignedUrl(
            formData,
            hdr
          );
          console.log("External API response:", externalResponse.data);

          if (externalResponse.data.success == true) {
            const { presignedUrl, filename } = externalResponse.data.data;

            const blob = await (await fetch(croppedImage)).blob();

            const uploadResponse = await fetch(presignedUrl, {
              method: "PUT",
              headers: {
                "Content-Type": blob.type,
                "x-amz-acl": "public-read",
              },
              body: blob,
            });

            if (!uploadResponse.ok) {
              const errorText = await uploadResponse.text();
              console.error("S3 Upload Failed:", errorText);
              throw new Error("Failed to upload file to S3: " + errorText);
            }

            values["img"] = filename;
          } else {
            toast.error("External upload failed", { theme: "colored" });
            toast.dismiss(toastContainerId);
            setDisabled(false);
            return;
          }
        } catch (error) {
          console.error("External API error:", error);
          toast.error("External upload failed", { theme: "colored" });
          toast.dismiss(toastContainerId);
          setDisabled(false);
          return;
        }
      } else {
        // Bypass: no presigned API call
        values["logo_pic"] = croppedImage;
      }
    }
    DataService.editTeam(values, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);
        // console.log('edit response')
        // console.log(response)
        if (response.success == true) {
          toast.success(response.msg, {
            theme: "dark",
            position: "bottom-center",
          });

          if (getpageData != 0) {
            const updateitem = getpageData.responsedata.list.filter(
              (ele, ind) => {
                if (ele.tid == values.tid) {
                  ele.name = values.name;
                  ele.sname = values.srtname;
                  ele.srtkey = values.srtkey;
                  ele.color = color;
                  ele.forcolor1 = color1;
                  ele.forcolor2 = color2;
                  ele.forcolor3 = color3;
                  ele.forcolor4 = color4;

                  if (
                    response.data.logo != "" &&
                    response.data.logo != null &&
                    response.data.logo != "null"
                  ) {
                    ele.logo = response.data.logo;
                  }
                }

                return ele;
              }
            );

            let responsedata = {
              responsedata: {
                path: getpageData.responsedata.path,
                aid: aid,
                list: updateitem,
              },
            };

            dispatch(teamlistData(responsedata));

            // Only send workhistory if logo was actually changed/added
            const logoWasChanged =
              croppedImage && croppedImage !== "" && croppedImage !== "#";

            if (logoWasChanged) {
              var logocount = 0;
              getpageData.responsedata.list.map((ele) => {
                if (ele.logo != "") {
                  logocount += 1;
                }
              });
              const db = getDatabase();
              if (logocount > 2) {
                // Query just the latest entry
                const workhistoryRef = ref(db, "map/info/workhistory");
                const latestEntryQuery = query(
                  workhistoryRef,
                  // orderByChild('timestamp'),
                  limitToLast(1)
                );

                get(latestEntryQuery)
                  .then((snapshot) => {
                    let shouldAdd = true;

                    if (snapshot.exists()) {
                      // Get the single latest entry
                      const latestEntry = Object.values(snapshot.val())[0];

                      if (
                        latestEntry.worktyp === "work6" &&
                        latestEntry.id === admin_id
                      ) {
                        shouldAdd = false;
                      }
                    }

                    if (shouldAdd) {
                      // console.log('should object')
                      var data = {};
                      data["work6"] = 3;
                      update(ref(db, "map/info/datastatus/" + aid), data);

                      var workhistory = {
                        worktyp: "work6",
                        id: admin_id,
                        name: admin_name,
                        timestamp: new Date().toISOString(),
                        aname: auction_name,
                        aid: aid,
                      };

                      try {
                        push(ref(db, "map/info/workhistory"), workhistory);
                      } catch (error) {
                        console.log(error);
                      }
                    }
                  })
                  .catch((error) => {
                    console.log("Error getting latest workhistory:", error);
                  });
              }
            }
          }
          // console.log('way 7')

          const db = getDatabase();
          // console.log(values)
          set(ref(db, "map/info/" + aid), {
            type: "2",
            upd: "2",
            id: decode(tid),
            detail: {
              name: values.name,
              srtname: values.srtname,
              srtkey: values.srtkey,
              logo: response.data.logo,
            },
            tkn: updtoken,
          });
          // console.log('way 8')

          history.push(BASE_PATH + "auction-team");
        } else {
          toast.error(response.msg, { theme: "colored" });
        }

        setDisabled(false);
        setIsUploading(false);
      })
      .catch((error) => {
        // console.log("Not valid");
        console.log(error);
        toast.dismiss(toastContainerId);
        toast.error("Not valid Server Error", { theme: "colored" });
        setDisabled(false);
        setIsUploading(false);
      });
  };

  const handleShowColorPicker = (color) => {
    if (color === "color") {
      setshowColor(!showColor);
    }
    if (color === "color1") {
      setshowColor1(!showColor1);
    }
    if (color === "color2") {
      setshowColor2(!showColor2);
    }
    if (color === "color3") {
      setshowColor3(!showColor3);
    }
    if (color === "color4") {
      setshowColor4(!showColor4);
    }
  };

  useEffect(() => {
    if (getpageData != 0) {
      setalphabetsInArray(
        getpageData.responsedata.list.map((obj) => obj.srtkey)
      );
    }

    $(".crop-default").click(function () {
      $("#crop-pic").click();
    });

    const updateitem = getpageData.responsedata?.list?.filter((ele, ind) => {
      if (ele.tid == decode(tid)) {
        setValue("name", ele.name);
        setValue("srtname", ele.sname);
        setValue("srtkey", ele.srtkey);
        setsrtkeyval(ele.srtkey);
        setsrtkeyvalnew(ele.srtkey);
        setColor(ele.color === null ? "" : ele.color);
        setColor1(ele.forcolor1 === null ? "" : ele.forcolor1);
        setColor2(ele.forcolor2 === null ? "" : ele.forcolor2);
        setColor3(ele.forcolor3 === null ? "" : ele.forcolor3);
        setColor4(ele.forcolor4 === null ? "" : ele.forcolor4);
        // console.log(ele.logo)
        if (ele.logo !== "" && ele.logo !== null) {
          setdefimg(getpageData.responsedata.path + ele.logo);
          // console.log("err")
        }
        $(".crop-default img").attr(
          "src",
          ele.logo
            ? `${getpageData.responsedata.path}${ele.logo}`
            : teamdefaultLogo
        );
        if (ele.logo != null && ele.logo != "") {
          setLogo(`${getpageData.responsedata.path}${ele.logo}`);
        }
      }
    });
  }, [Demo]);
  useEffect(() => {
    const isFirstMount = localStorage.getItem("isFirstMount");
    // console.log('isFirstMount')
    // console.log(isFirstMount)
    if (!isFirstMount) {
      localStorage.setItem("isFirstMount", false);
    } else {
      localStorage.removeItem("isFirstMount");
      history.push("/auction-detail");
    }
  }, [history]);
  const firechange = (datasnap) => {
    if (datasnap.type == "1" && datasnap.upd == "3") {
      if (getaucpageData != 0) {
        const updateitem = getaucpageData.responsedata.list.filter(
          (ele) => ele.aid != datasnap.id
        );

        let responsedata = {
          responsedata: {
            path: getaucpageData.responsedata.path,
            cid: cid,
            list: updateitem,
          },
        };
        dispatch(actlistData(responsedata));
      }
      history.push(BASE_PATH + "my-auction");
    }
  };
  useEffect(() => {
    if (upddata !== null) {
      if (upddata !== isfirsttime) {
        firechange(upddata);
        if (upddata.upd == "4") {
          dispatch(setisfirsttime(upddata));
        }
      }
    }
  }, [upddata]);

  return (
    <>
      <div>
        <Navigationtitle data={match} />
        <div
          id="top-categories"
          className="top-cat-area default-padding bottom-less"
        >
          <div className="container-fluid ">
            <div className="row">
              <div id="contact-us" className="reg-area">
                <div className="container-fluid">
                  <div className="row">
                    <div className="reg-items">
                      <div className="col-md-5  reg-form">
                        <form
                          onSubmit={handleSubmit(onSubmit)}
                          action=""
                          autoComplete="off"
                          encType="multipart/form-data"
                        >
                          <input
                            className="form-control"
                            type="hidden"
                            defaultValue={logo}
                            {...register("logo")}
                            id="logo"
                          />
                          <input
                            type="hidden"
                            value={decode(tid)}
                            {...register("tid")}
                          />
                          <div className="row myclass1">
                            <div className="col-md-12 team-margintop">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label typeof="logo" className="team-label">
                                    {" "}
                                    Team Logo {/*logo*/}{" "}
                                  </label>
                                </div>
                                <div className="col-md-6">
                                  {" "}
                                  <div style={{ clear: "both" }}></div>
                                  <ImageCropper1
                                    croppedImage={croppedImage}
                                    defaultimage={defimg}
                                    setCroppedImage={setCroppedImage}
                                    setOriginalFileName={setOriginalFileName}
                                  />
                                  {/* {localStorage.getItem('crp_typ') == 0 ?
                                    <ImageCropper2
                                    croppedImage={croppedImage}
                                      defaultImage={defimg}
                                      setCroppedImage={setCroppedImage}
                                      setOriginalFileName={setOriginalFileName}
                                    /> :
                                    <ImageCropper1
                                      croppedImage={croppedImage}
                                      defaultimage={defimg}
                                      setCroppedImage={setCroppedImage}
                                      setOriginalFileName={setOriginalFileName}
                                    />
                                  } */}
                                  {/* {logo != null ? (
                                    <Image
                                      className="user-pic"
                                      fallback={
                                        <Shimmer width={265} height={265} />
                                      }
                                      src={logo}
                                    ></Image>
                                  ) : (
                                    <></>
                                  )} */}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-12 margin-top-14px team-margintop">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  <label typeof="name" className="team-label">
                                    {" "}
                                    Team Name *{" "}
                                  </label>
                                </div>
                                <div className="col-md-10">
                                  <input
                                    className="form-control team-input"
                                    type="text"
                                    {...register("name", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  />
                                  {errors.name && (
                                    <p className="text-error">
                                      {errors.name.message}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>

                            {/* <div className="col-md-12 margin-top-14px">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label typeof="srtname">
                                    {" "}
                                    Team Short Name *{" "}
                                  </label>
                                </div>
                                <div className="col-md-3">
                                  {" "}
                                  <input
                                    className="form-control"
                                    type="text"
                                    {...register("srtname", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  />
                                  {errors.srtname && (
                                    <p className="text-error">
                                      {errors.srtname.message}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  <label typeof="srtkey">
                                    {" "}
                                    Team Keyword *{" "}
                                  </label>
                                </div>
                                <div className="col-md-3">
                                  {" "}
                                  <select
                                    className="form-control"
                                    type="text"
                                    {...register("srtkey", {
                                      // required: true,
                                      // required: "required field.",
                                    })}
                                    id="srtkey"
                                  >
                                    <option value="">--select--</option>
                                    {getAlpha()?.map((dt, key) => {
                                      return <option value={dt}>{dt}</option>;
                                    })}
                                  </select>
                                  {errors.srtkey && (
                                    <p className="text-error">
                                      {errors.srtkey.message}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div> */}
                            <div className="col-md-6 margin-top-14px team-margintop">
                              <div className="col-md-4">
                                <label className="team-label">
                                  {" "}
                                  Team Short Name *{" "}
                                </label>
                              </div>
                              <div className="col-md-8">
                                {/* <div className="col-md-3"> */}{" "}
                                <input
                                  className="form-control team-input"
                                  type="text"
                                  {...register("srtname", {
                                    required: true,
                                    required: "required field.",
                                  })}
                                />
                                {errors.srtname && (
                                  <p className="text-error">
                                    {errors.srtname.message}
                                  </p>
                                )}
                              </div>
                              {/* </div> */}
                            </div>
                            <div className="col-md-6 margin-top-14px team-margintop">
                              <div className="col-md-4">
                                <label className="team-label">
                                  {" "}
                                  Team Keyword{" "}
                                </label>
                              </div>
                              <div className="col-md-8">
                                {" "}
                                <select
                                  className="form-control shortkey-control"
                                  type="text"
                                  {...register("srtkey", {
                                    // required: true,
                                    // required: "required field.",
                                  })}
                                  value={srtkeyvalnew}
                                  onChange={(e) => {
                                    setsrtkeyvalnew(e.target.value);
                                  }}
                                  id="srtkey"
                                >
                                  <option value="">--select--</option>
                                  {getAlpha()?.map((dt, key) => {
                                    if (getpageData != 0) {
                                      if (
                                        !alphabetsInArray.includes(dt) ||
                                        dt == srtkeyval
                                      ) {
                                        return <option value={dt}>{dt}</option>;
                                      }
                                    } else {
                                      return <option value={dt}>{dt}</option>;
                                    }
                                  })}
                                </select>
                                {errors.srtkey && (
                                  <p className="text-error">
                                    {errors.srtkey.message}
                                  </p>
                                )}
                              </div>
                            </div>

                            <div className="col-md-6 margin-top-14px team-margintop">
                              <div className="col-md-4">
                                <label className="team-label">
                                  {" "}
                                  Team BG Color{" "}
                                </label>
                              </div>
                              <div className="col-md-8">
                                <div
                                  className="choose-color-div"
                                  id="team-bid-color"
                                  onClick={() => {
                                    handleShowColorPicker("color");
                                  }}
                                >
                                  <div className="choose-color-text">
                                    Choose Color
                                  </div>{" "}
                                  {color && (
                                    <div
                                      className="circle"
                                      style={{ backgroundColor: color }}
                                    >
                                      <span
                                        onClick={() => setColor("")}
                                        className="defcolor"
                                      >
                                        X
                                      </span>
                                    </div>
                                  )}{" "}
                                </div>
                                {showColor ? (
                                  <div className="choose-picker-div">
                                    <ColorPicker
                                      setColor={setColor}
                                      color={color}
                                      allowNoColor={true}
                                    />
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                            <div className="col-md-6 margin-top-14px team-margintop">
                              <div className="col-md-4">
                                <label className="team-label">
                                  {" "}
                                  Team Color{" "}
                                </label>
                              </div>
                              <div className="col-md-8">
                                <div
                                  className="choose-color-div"
                                  onClick={() => {
                                    handleShowColorPicker("color1");
                                  }}
                                >
                                  <div className="choose-color-text">
                                    Choose Color
                                  </div>{" "}
                                  {}
                                  {color1 && (
                                    <div
                                      className="circle"
                                      style={{ backgroundColor: color1 }}
                                    >
                                      <span
                                        onClick={() => setColor1("")}
                                        className="defcolor"
                                      >
                                        X
                                      </span>
                                    </div>
                                  )}{" "}
                                </div>
                                {showColor1 ? (
                                  <div className="choose-picker-div">
                                    <ColorPicker
                                      setColor={setColor1}
                                      color={color1}
                                    />
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                            <div className="col-md-6 margin-top-14px team-margintop">
                              <div className="col-md-4">
                                <label className="team-label">
                                  {" "}
                                  Team Bid Color{" "}
                                </label>
                              </div>
                              <div className="col-md-8">
                                <div
                                  className="choose-color-div"
                                  onClick={() => {
                                    handleShowColorPicker("color2");
                                  }}
                                >
                                  <div className="choose-color-text">
                                    Choose Color
                                  </div>{" "}
                                  {color2 && (
                                    <div
                                      className="circle"
                                      style={{ backgroundColor: color2 }}
                                    >
                                      <span
                                        onClick={() => setColor2("")}
                                        className="defcolor"
                                      >
                                        X
                                      </span>
                                    </div>
                                  )}{" "}
                                </div>
                                {showColor2 ? (
                                  <div className="choose-picker-div">
                                    <ColorPicker
                                      setColor={setColor2}
                                      color={color2}
                                    />
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                            <div className="col-md-6 margin-top-14px team-margintop">
                              <div className="col-md-4">
                                <label className="team-label">
                                  {" "}
                                  Team Max Color{" "}
                                </label>
                              </div>
                              <div className="col-md-8">
                                <div
                                  className="choose-color-div"
                                  onClick={() => {
                                    handleShowColorPicker("color3");
                                  }}
                                >
                                  <div className="choose-color-text">
                                    Choose Color
                                  </div>{" "}
                                  {color3 && (
                                    <div
                                      className="circle"
                                      style={{ backgroundColor: color3 }}
                                    >
                                      <span
                                        onClick={() => setColor3("")}
                                        className="defcolor"
                                      >
                                        X
                                      </span>
                                    </div>
                                  )}{" "}
                                </div>
                                {showColor3 ? (
                                  <div className="choose-picker-div">
                                    <ColorPicker
                                      setColor={setColor3}
                                      color={color3}
                                    />
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                            <div className="col-md-6 margin-top-14px team-margintop">
                              <div className="col-md-4">
                                <label className="team-label">
                                  {" "}
                                  Team Res. Color{" "}
                                </label>
                              </div>
                              <div className="col-md-8">
                                <div
                                  className="choose-color-div"
                                  onClick={() => {
                                    handleShowColorPicker("color4");
                                  }}
                                >
                                  <div className="choose-color-text">
                                    Choose Color
                                  </div>{" "}
                                  {color4 && (
                                    <div
                                      className="circle"
                                      style={{ backgroundColor: color4 }}
                                    >
                                      <span
                                        onClick={() => setColor4("")}
                                        className="defcolor"
                                      >
                                        X
                                      </span>
                                    </div>
                                  )}{" "}
                                </div>
                                {showColor4 ? (
                                  <div className="choose-picker-div">
                                    <ColorPicker
                                      setColor={setColor4}
                                      color={color4}
                                    />
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>

                            <div className="col-md-12">
                              <button
                                className="button teams-btn"
                                type="submit"
                                style={{
                                  marginLeft: "16px",
                                  borderRadius: "8px",
                                }}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Editteam;
